import { useField } from 'formik'
import { Ref, useCallback } from 'react'
import { Radio as AntdRadio } from '../../Radio'
import type {
  RadioProps as AntdRadioProps,
  RadioChangeEvent as AntdRadioChangeEvent,
  RadioRef as AntdRadioRef
} from '../../Radio'
import type { FormikFieldProps } from '../typings/FieldProps'

export type RadioChangeEvent = AntdRadioChangeEvent

export type RadioProps = FormikFieldProps &
  AntdRadioProps & {
    ref?: Ref<RadioRef>
  }
export type RadioRef = AntdRadioRef

export const Radio = ({
  name,
  onChange: onChangeProp,
  ...restProps
}: RadioProps) => {
  const [field, , helpers] = useField(name)
  const { value } = field
  const { setValue, setTouched } = helpers

  const handleChange = useCallback(
    (event: RadioChangeEvent) => {
      setValue(event.target.value)
      onChangeProp?.(event)
    },
    [onChangeProp, setValue]
  )

  const handleBlur = useCallback(() => {
    setTouched(true)
    // restProps?.onBlur(event)
  }, [setTouched])

  return (
    <AntdRadio
      name={name}
      value={value}
      onChange={handleChange}
      onBlur={handleBlur}
      {...restProps}
    />
  )
}
